import { PlanFeatureName } from "shared/datamodel/schemas";
import usePlanFeatureValue from "./use-plan-features";

export function useApplyViewerRestricted() {
  const applyViewerRestricted = usePlanFeatureValue(PlanFeatureName.APPLY_VIEWER_RESTRICTED);
  return applyViewerRestricted === true;
}
